"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),t=require("react/jsx-runtime"),i=require("@vds/typography"),n=require("styled-components"),o=require("@vds/button-icons"),a=require("@vds/buttons"),s=require("@vds/icons"),r=require("@vds-tokens/core"),l=require("@plans/utilities"),d=require("../tile/index.js");function c(e){return e&&e.__esModule?e:{default:e}}var u=c(n);const p=u.default.div.withConfig({displayName:"TileContainer",componentId:"VDS__sc-1vt6bi6-0"})`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media (min-width: ${l.breakpoints.tabletSmall.min}) {
    align-items: center;
    justify-items: space-between;
  }
`,m=u.default.div.withConfig({displayName:"TopWrapper",componentId:"VDS__sc-1vt6bi6-1"})`
  display: flex;
  flex-direction: row;
  margin-bottom: ${r.LayoutTokens.space["3X"].value};
  @media (min-width: ${l.breakpoints.tabletSmall.min}) {
    margin-bottom: 0;
  }
`,b=u.default.div.withConfig({displayName:"TextWrapper",componentId:"VDS__sc-1vt6bi6-2"})`
  display: flex;
  flex-direction: column;
  width: auto;
`,f=u.default.div.withConfig({displayName:"LeftContent",componentId:"VDS__sc-1vt6bi6-3"})`
  display: flex;
  flex-direction: column;
  @media (min-width: ${l.breakpoints.tabletSmall.min}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-right: 0;
  }
`,g=u.default.div.withConfig({displayName:"ButtonWrapper",componentId:"VDS__sc-1vt6bi6-4"})`
  > div > div {
    padding-bottom: 0;
  }
  @media (min-width: ${l.breakpoints.tabletSmall.min}) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-left: ${r.LayoutTokens.space["3X"].value};
  }
`,h=u.default.div.withConfig({displayName:"CloseButtonWrapper",componentId:"VDS__sc-1vt6bi6-5"})`
  box-sizing: border-box;
  display: flex;
  margin-left: ${r.LayoutTokens.space["3X"].value};
  @media (min-width: ${l.breakpoints.tabletSmall.min}) {
    margin-left: ${r.LayoutTokens.space["4X"].value};
  }
`,x=u.default.div.withConfig({displayName:"ImageWrapper",componentId:"VDS__sc-1vt6bi6-6"})`
  height: 56px;
  margin-right: ${r.LayoutTokens.space["3X"].value};
  width: 56px;
`,v=u.default.img.withConfig({displayName:"StyledImage",componentId:"VDS__sc-1vt6bi6-7"})`
  border: ${({surface:e})=>"dark"===e?r.ColorTokens.elements.lowcontrast.ondark.value:r.ColorTokens.elements.lowcontrast.onlight.value};
  border-radius: 8px;
  height: 56px;
  width: 56px;
`,y=u.default.div.withConfig({displayName:"Padding",componentId:"VDS__sc-1vt6bi6-8"})`
  padding-bottom: ${r.LayoutTokens.space["1X"].value};
`;exports.default=n=>{const{surface:l="dark",buttonGroup:c,title:u,body:w,image:j,closeButton:_}=n,k=e.__rest(n,["surface","buttonGroup","title","body","image","closeButton"]),C="dark"===l?r.ColorTokens.elements.primary.ondark.value:r.ColorTokens.elements.primary.onlight.value;return t.jsx(d.default,Object.assign({padding:"16px",width:"100%",height:"auto",borderRadius:"16px",backgroundColor:"dark"===l?"black":"white",surface:l,showDropShadow:!0},k,{children:t.jsxs(p,{children:[t.jsxs(f,Object.assign({closeButton:_},{children:[t.jsxs(m,{children:[j&&t.jsx(x,{children:t.jsx(v,Object.assign({},j))}),t.jsxs(b,{children:[t.jsx(i.Body,Object.assign({color:C,size:"small",bold:!0},u)),t.jsx(y,{}),t.jsx(i.Body,Object.assign({color:C,size:"small"},w))]})]}),c&&t.jsx(g,{children:t.jsx(a.ButtonGroup,Object.assign({surface:l},c))})]})),_&&t.jsx(h,{children:t.jsx(o.ButtonIcon,Object.assign({},_,{size:"small",kind:"lowContrast",surface:l,renderIcon:e=>t.jsx(s.Icon,Object.assign({name:"close"},e))}))})]})}))};
